import { render, staticRenderFns } from "./RegionComponent.vue?vue&type=template&id=644d9e16&scoped=true"
import script from "./RegionComponent.vue?vue&type=script&lang=js"
export * from "./RegionComponent.vue?vue&type=script&lang=js"
import style0 from "./RegionComponent.vue?vue&type=style&index=0&id=644d9e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644d9e16",
  null
  
)

export default component.exports